import { SVGProps } from "react";

const TableauDuBordIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_750_1520)">
        <path
          d="M17.4137 22.4282C17.2965 22.6063 17.1044 22.7142 16.8934 22.7142H7.10592C6.89498 22.7142 6.6981 22.6063 6.5856 22.4282C6.4731 22.2548 6.45904 22.0392 6.53873 21.8517C6.77779 21.3173 7.31217 20.9751 7.8981 20.9751H9.06998V19.9438H14.934V20.9751H16.1059C16.6919 20.9751 17.2215 21.322 17.4653 21.8517C17.545 22.0392 17.5262 22.2595 17.4137 22.4282Z"
          fill="#43454E"
        />
        <path
          d="M7.81406 7.65478C7.49062 8.85947 6.38437 9.7501 5.08125 9.7501C3.52031 9.74541 2.25 8.47978 2.25 6.91885C2.25 5.61103 3.14062 4.50947 4.34531 4.18604C4.3125 4.3126 4.33125 4.22822 4.32656 6.91885C4.32656 7.33135 4.66406 7.66885 5.07656 7.66885C7.75312 7.66416 7.68281 7.67822 7.81406 7.65478Z"
          fill="#43454E"
        />
        <path
          d="M7.90898 6.91885C7.90898 7.05479 7.79648 7.16728 7.66055 7.16728H5.08242C4.94648 7.16728 4.83398 7.05479 4.83398 6.91885V4.34072C4.83398 4.2001 4.94648 4.09229 5.08242 4.09229C6.64336 4.09229 7.90898 5.35791 7.90898 6.91885Z"
          fill="#43454E"
        />
        <path
          d="M7.65937 11.263H2.49844C2.3625 11.263 2.25 11.1505 2.25 11.0146C2.25 10.8786 2.3625 10.7661 2.49844 10.7661H7.65937C7.79531 10.7661 7.90781 10.8786 7.90781 11.0146C7.90781 11.1505 7.79531 11.263 7.65937 11.263Z"
          fill="#43454E"
        />
        <path
          d="M7.65937 12.7356H2.49844C2.3625 12.7356 2.25 12.6231 2.25 12.4872C2.25 12.3513 2.3625 12.2388 2.49844 12.2388H7.65937C7.79531 12.2388 7.90781 12.3513 7.90781 12.4872C7.90781 12.6278 7.79531 12.7356 7.65937 12.7356Z"
          fill="#43454E"
        />
        <path
          d="M7.65937 14.2122H2.49844C2.3625 14.2122 2.25 14.0997 2.25 13.9638C2.25 13.8278 2.3625 13.7153 2.49844 13.7153H7.65937C7.79531 13.7153 7.90781 13.8278 7.90781 13.9638C7.90781 14.0997 7.79531 14.2122 7.65937 14.2122Z"
          fill="#43454E"
        />
        <path
          d="M12.4871 10.0489V13.7099C12.4871 13.9864 12.2621 14.2114 11.9855 14.2114H10.9449C10.6684 14.2114 10.4434 13.9864 10.4434 13.7099V10.0489C10.4434 9.77236 10.6637 9.54736 10.9449 9.54736H11.9855C12.2621 9.54736 12.4871 9.77236 12.4871 10.0489Z"
          fill="#43454E"
        />
        <path
          d="M15.577 7.4708V13.7099C15.577 13.9864 15.352 14.2114 15.0754 14.2114H14.0348C13.7582 14.2114 13.5332 13.9864 13.5332 13.7099V7.4708C13.5332 7.19424 13.7535 6.96924 14.0348 6.96924H15.0754C15.352 6.96924 15.577 7.19424 15.577 7.4708Z"
          fill="#43454E"
        />
        <path
          d="M18.6598 10.0489V13.7099C18.6598 13.9864 18.4348 14.2114 18.1582 14.2114H17.1129C16.8363 14.2114 16.6113 13.9864 16.6113 13.7099V10.0489C16.6113 9.77236 16.8363 9.54736 17.1129 9.54736H18.1582C18.4348 9.54736 18.6598 9.77236 18.6598 10.0489Z"
          fill="#43454E"
        />
        <path
          d="M21.7496 8.52158V13.7106C21.7496 13.9872 21.5246 14.2122 21.248 14.2122H20.2027C19.9262 14.2122 19.7012 13.9872 19.7012 13.7106V8.52158C19.7012 8.24502 19.9262 8.02002 20.2027 8.02002H21.248C21.5246 8.02002 21.7496 8.24502 21.7496 8.52158Z"
          fill="#43454E"
        />
        <path
          d="M17.64 8.25869C17.5697 8.25869 17.4994 8.22587 17.4479 8.16962L14.5322 4.70087L11.64 7.49462C11.5416 7.58837 11.3822 7.58837 11.2885 7.48994C11.1947 7.3915 11.1947 7.23212 11.2932 7.13837L14.3822 4.15712C14.4338 4.11025 14.4994 4.08212 14.5697 4.08681C14.64 4.0915 14.7057 4.12431 14.7479 4.17587L17.6869 7.67275L20.5885 5.62431C20.701 5.54462 20.8557 5.57275 20.9354 5.68525C21.015 5.79775 20.9869 5.95244 20.8744 6.03212L17.7854 8.2165C17.7432 8.24462 17.6916 8.25869 17.64 8.25869Z"
          fill="#43454E"
        />
        <path
          d="M12.0004 17.1138C11.8129 17.1138 11.6582 17.2685 11.6582 17.456C11.6582 17.6435 11.8129 17.7981 12.0004 17.7981C12.1879 17.7981 12.3426 17.6435 12.3426 17.456C12.3426 17.2685 12.1879 17.1138 12.0004 17.1138Z"
          fill="#43454E"
        />
        <path
          d="M22.7484 1.83643H1.25156C0.557813 1.83643 0 2.39424 0 3.0833C0 3.48174 0 19.1521 0 18.1958C0 18.8849 0.557813 19.4474 1.25156 19.4474H22.7531C23.4422 19.4474 24.0047 18.8849 24.0047 18.1958C24.0047 16.288 24.0047 4.98174 24.0047 3.0833C24 2.39424 23.4375 1.83643 22.7484 1.83643ZM12 18.2989C11.5359 18.2989 11.1562 17.9192 11.1562 17.4552C11.1562 16.9911 11.5359 16.6114 12 16.6114C12.4641 16.6114 12.8438 16.9911 12.8438 17.4552C12.8438 17.9192 12.4641 18.2989 12 18.2989ZM23.0016 15.4583H0.998437V3.0833C0.998437 2.94736 1.11094 2.83486 1.24688 2.83486H22.7484C22.8844 2.83486 22.9969 2.94736 22.9969 3.0833V15.4583H23.0016Z"
          fill="#43454E"
        />
      </g>
      <defs>
        <clipPath id="clip0_750_1520">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.275879)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TableauDuBordIcon;
